<template lang="html">
  <UInput
    placeholder="Введите Email"
    icon="i-lucide-mail"
  />
</template>

<script setup lang="ts">
</script>
